import { Button, Flex, Heading } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import MedicalCoditionsContainer from "./MedicalConditionsContainer";

export default function MedicalConditionsPage() {
  const navigate = useNavigate();
  return (
    <Flex
      direction="column"
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
    >
      <Flex direction="row" alignItems="center">
        <Heading level="1" children="Medical Conditions"></Heading>
        <Button
          size="small"
          variation="primary"
          onClick={() => navigate(`/user/hr/medical-problems/add`)}
        >
          Add
        </Button>
      </Flex>
      <MedicalCoditionsContainer />
    </Flex>
  );
}
